import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "previewContainer"]
  static values = {
    key: String
  }

  connect() {
    console.log("Hello, Site Image Upload Controller here!", this.element)
  }

  handleFileSelect(event) {
    const files = Array.from(event.target.files)
    if (files.length === 0) return

    this.showPreview()
    this.clearPreview()

    files.forEach((file, index) => {
      if (file.type.startsWith('image/')) {
        this.createPreview(file, index)
      }
    })
  }

  createPreview(file, index) {
    const reader = new FileReader()
    reader.onload = (e) => {
      const previewItem = document.createElement('div')
      previewItem.className = 'col-md-3 mb-3'
      previewItem.innerHTML = `
        <div class="card">
          <img src="${e.target.result}" class="card-img-top" style="height: 150px; object-fit: contain;">
          <div class="card-body p-2">
            <small class="text-muted">${file.name}</small>
            <div class="mt-2">
              <button type="button" class="btn btn-sm btn-outline-danger" data-action="click->image-upload#removePreview" data-index="${index}">
                Remove
              </button>
            </div>
          </div>
        </div>
      `
      this.previewContainerTarget.appendChild(previewItem)
    }
    reader.readAsDataURL(file)
  }

  removePreview(event) {
    const index = parseInt(event.target.dataset.index)
    const previewItems = this.previewContainerTarget.querySelectorAll('.col-md-3')
    if (previewItems[index]) {
      previewItems[index].remove()
    }

    // Also remove from file input
    const dt = new DataTransfer()
    const files = Array.from(this.fileInput.files)
    files.forEach((file, i) => {
      if (i !== index) {
        dt.items.add(file)
      }
    })
    this.fileInput.files = dt.files
  }

  removeImage(event) {
    event.preventDefault();
    event.stopPropagation();

    // const imageId = event.target.dataset.imageId
    // const key = event.target.dataset.key

    const removeImageUrl = event.params.removeImageUrl;

    console.log('Removing image', removeImageUrl)
    // debugger;

    // Send AJAX request to remove image
    fetch(`${removeImageUrl}`, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (response.ok) {
        event.target.closest('.col-md-3').remove()
      } else {
        alert('Failed to remove image')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Failed to remove image')
    })
  }

  showPreview() {
    this.previewTarget.style.display = 'block'
  }

  clearPreview() {
    this.previewContainerTarget.innerHTML = ''
  }
}
